<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="!isLoading"></cre-spinner>
</div>
<div class="cre-layout-content" [hidden]="isLoading">
  <p-tabView>
    <p-tabPanel header="Driver Search">
      <form id="driver-search-form" [formGroup]="driverSearchForm">
        <div class="p-grid p-col-12">
          <div class="p-col-12">
            <div class="p-col"><label for="driverCode">Driver Code</label></div>
            <div class="p-col">
              <span class="p-fluid">
                <input
                  autocomplete="off"
                  formControlName="driverCode"
                  id="driverCode"
                  maxlength="20"
                  pInputText
                  type="text"
                />
              </span>
            </div>
          </div>
          <div class="p-col-4">
            <div class="p-col">
              <button
                (click)="searchDrivers()"
                [disabled]="isDriverSearchLoading"
                id="searchDrivers"
                label="Search"
                pButton
                type="button"
              ></button>
            </div>
          </div>
          <div class="p-col-12" *ngIf="areDriverSearchResultsVisible">
            <p-table
              #ds
              [autoLayout]="true"
              [columns]="driverSearchColumns"
              extraFilterConstraints
              [loading]="isDriverSearchLoading"
              [paginator]="true"
              [resizableColumns]="true"
              [responsive]="true"
              [rows]="10"
              selectionMode="single"
              [value]="driverSearchResults"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th
                    *ngFor="let col of driverSearchColumns"
                    pResizableColumn
                    [pSortableColumn]="col.field"
                  >
                    {{ col.header }}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </th>
                </tr>
                <tr>
                  <th *ngFor="let col of driverSearchColumns">
                    <span class="p-fluid">
                      <input
                        (input)="ds.filter($event.target.value, col.field, 'contains')"
                        pInputText
                        type="text"
                        [value]="ds.filters[col.field]?.value"
                      />
                    </span>
                  </th>
                </tr>
              </ng-template>
              <ng-template let-data pTemplate="body">
                <tr (dblclick)="onRowDblClick($event, data)" [pSelectableRow]="data">
                  <td *ngFor="let col of driverSearchColumns">
                    <div *ngIf="!['phoneNumber'].includes(col.field)">
                      <span class="p-column-title">{{ col.header }}</span>
                      {{ data[col.field] }}
                    </div>
                    <div *ngIf="['phoneNumber'].includes(col.field)">
                      <span class="p-column-title">{{ col.header }}</span>
                      {{ data[col.field] | phone: 'US' }}
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="ds.columns.length">
                    <span *ngIf="isDriverSearchLoading">Loading...</span>
                    <span *ngIf="!isDriverSearchLoading">No records found</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </form>
    </p-tabPanel>
  </p-tabView>
</div>
